import React, { useEffect, useState } from "react";
import { Container } from "./styles";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../../../services/api";
import { toast } from "react-toastify";
import { addSeconds, format, intervalToDuration } from "date-fns";
import Status from "../../../components/status";
import { Button, Pagination, Spin, Modal } from "antd";
import { formatarDuracaoCompleta } from "../../../services/functions";
import CountUp from "react-countup";
import { Card, Message } from "../../../GlobalStyles";

export default function SolicitacoesUrgente() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(() => {
    return Number(searchParams.get("page")) || 0;
  });
  const [ordersTotal, setOrdersTotal] = useState(0);

  const [visibleModalItems, setVisibleModalItems] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    setSearchParams({ page }, { replace: true });
    loadingOSs();
  }, [page]);

  async function loadingOSs() {
    setLoading(true);
    await api
      .get(`/orders-urgente?page=${page}`)
      .then((response) => {
        const formattedOrders = (response.data.orders || []).map((item) => {
          let tS = item.totalServices;
          if (tS === undefined && item.items) {
            tS = item.items.reduce((acc, curr) => acc + (curr.amount || 0), 0);
          }
          return {
            ...item,
            totalServices: tS || 0,
          };
        });
        setOrders(formattedOrders);
        setOrdersTotal(response.data.ordersTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente",
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente",
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setLoading(false);
  }

  return (
    <Container>
      <h1>OSs Urgentes</h1>
      {loading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <Card>
            <p>Total</p>
            <CountUp separator="." duration={1} end={ordersTotal} />
          </Card>
          {orders.length == 0 && (
            <Message>Nenhuma Ordem de Serviço solicitada até o momento</Message>
          )}
          <div className="orders">
            {orders.map((item) => {
              return (
                <div className="order">
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {item.urgent && (
                      <Status
                        isUrgent={true}
                        style={{
                          marginRight: 10,
                          marginBottom: 7,
                          flexFlow: "nowrap",
                        }}
                      />
                    )}
                    {item.name && (
                      <p
                        style={{ width: "100%", fontSize: 11, marginBottom: 8 }}
                      >
                        {item.name}
                      </p>
                    )}
                  </div>
                  <div
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <p className="title" style={{ marginBottom: 5 }}>
                      {("00000" + item.id).slice(-5)}{" "}
                    </p>
                    <Button
                      type="link"
                      className="back"
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        padding: "4px 12px",
                        height: "auto",
                        background: "#fff",
                        borderRadius: "50px",
                        color: "#52c41a",
                        border: "1px solid #b7eb8f",
                        display: "inline-flex",
                        alignItems: "center",
                        marginLeft: 0,
                        alignSelf: "flex-start",
                        maxWidth: "none",
                      }}
                      onClick={() => {
                        setSelectedItems(item.items || []);
                        setVisibleModalItems(true);
                      }}
                    >
                      {item.totalServices} serviço{item.totalServices !== 1 && "s"}
                    </Button>
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <div style={{ minWidth: 250, marginRight: 50 }}>
                      <p className="title">Status</p>
                      <Status status={item.status} urgent={item.urgent} />
                    </div>
                    <div className="item">
                      <p className="title">Última atualização</p>
                      <p
                        className="back"
                        style={{
                          fontSize: 12,
                        }}
                      >
                        {format(new Date(item.update_at), "dd/MM/yyyy HH:mm")}
                      </p>
                    </div>
                  </div>
                  <Button
                    type="primary"
                    onClick={() => {
                      navigate("/admin/os/" + item.id);
                    }}
                  >
                    Detalhes
                  </Button>

                  {!!item.averageTime && (
                    <p style={{ width: "100%", fontSize: 11, marginTop: 10 }}>
                      OS concluida em{" "}
                      {formatarDuracaoCompleta(
                        intervalToDuration({
                          start: new Date(),
                          end: addSeconds(new Date(), item.averageTime),
                        }),
                      )}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
          <Pagination
            style={{
              margin: "25px 0",
              alignSelf: "center",
            }}
            defaultCurrent={page + 1}
            pageSize={30}
            onChange={(page) => {
              setPage(page - 1);
            }}
            total={ordersTotal}
          />
        </>
      )}
      <Modal
        title="Listagem de Serviços"
        open={visibleModalItems}
        onCancel={() => setVisibleModalItems(false)}
        footer={[
          <Button key="close" onClick={() => setVisibleModalItems(false)}>
            Fechar
          </Button>,
        ]}
      >
        {selectedItems.length > 0 ? (
          <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontWeight: "bold",
                borderBottom: "1px solid #f0f0f0",
                padding: "10px 0",
              }}
            >
              <span>Serviço</span>
              <span>Quantidade</span>
            </div>
            {selectedItems.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "10px 0",
                  borderBottom: "1px solid #f0f0f0",
                }}
              >
                <span>{item.name}</span>
                <span>{item.amount}x</span>
              </div>
            ))}
          </div>
        ) : (
          <p>Nenhum serviço encontrado para esta OS.</p>
        )}
      </Modal>
    </Container>
  );
}
